import { api } from './index';

// IVF Procedures API Service - Legacy wrapper for backwards compatibility
export const ivfAPI = {
  // Search patients
  searchPatients: async (searchTerm, limit = 10, offset = 0) => {
    return api.ivf.searchPatients(searchTerm, limit, offset);
  },

  // Get procedure types
  getProcedureTypes: async () => {
    return api.ivf.getProcedureTypes();
  },

  // Create draft procedure
  createDraftProcedure: async (contactId, procedureType, procedureSubType = 'SELF') => {
    return api.ivf.createDraftProcedure(contactId, procedureType, procedureSubType);
  },

  // Get procedures by contact
  getProceduresByContact: async (contactId) => {
    return api.ivf.getProceduresByContact(contactId);
  },

  // Get draft procedures by contact
  getDraftProcedures: async (contactId) => {
    return api.ivf.getDraftProcedures(contactId);
  },

  // Get procedure by ID
  getProcedureById: async (procedureId) => {
    return api.ivf.getProcedureById(procedureId);
  },

  // Search procedures with filters
  searchProcedures: async (params) => {
    return api.ivf.searchProcedures(params);
  },
};

export default ivfAPI;
